<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-11 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title">FAQ</h3>
                        <div [innerHTML]="nav"></div>
                        <p>&nbsp;</p>
                        <div  [innerHTML]="questions"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
